'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * # poller配置类型
 *
 * ```
 *  new Poller({
 *    delay: 500,
 *    smart: false,
 *    action: () => {
 *      return Beatle.Ajax.get('...');
 *    },
 *    catchError: (err) => {
 *    }
 *  })
 * ```
 */
exports.default = {
  delay: _propTypes2.default.number,
  smart: _propTypes2.default.bool,
  action: _propTypes2.default.func.isRequired,
  catchError: _propTypes2.default.func
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/pollerShape.js
// module id = 139
// module chunks = 0